var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46467 7.36963C7.10402 7.36963 6.8125 7.60285 6.8125 7.89137V12.0653C6.8125 12.3538 7.10402 12.587 7.46467 12.587C7.82533 12.587 8.11685 12.3538 8.11685 12.0653V7.89137C8.11685 7.60285 7.82533 7.36963 7.46467 7.36963Z",
    fill: "#F04A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7303 7.36963C10.3696 7.36963 10.0781 7.60285 10.0781 7.89137V12.0653C10.0781 12.3538 10.3696 12.587 10.7303 12.587C11.091 12.587 11.3825 12.3538 11.3825 12.0653V7.89137C11.3825 7.60285 11.091 7.36963 10.7303 7.36963Z",
    fill: "#F04A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8098 1.5H7.38587C6.75644 1.5 6.24457 2.0175 6.24457 2.65385V3.80769H4.53261H2.82065C2.50508 3.80769 2.25 4.06558 2.25 4.38462C2.25 4.70365 2.50508 4.96154 2.82065 4.96154H3.96196V14.7692C3.96196 15.7235 4.73005 16.5 5.67391 16.5H12.5217C13.4656 16.5 14.2337 15.7235 14.2337 14.7692V4.96154H15.375C15.6906 4.96154 15.9457 4.70365 15.9457 4.38462C15.9457 4.06558 15.6906 3.80769 15.375 3.80769H13.663H11.9511V2.65385C11.9511 2.0175 11.4392 1.5 10.8098 1.5ZM13.0924 14.7692C13.0924 15.0877 12.8367 15.3462 12.5217 15.3462H5.67391C5.35891 15.3462 5.10326 15.0877 5.10326 14.7692V4.96154H13.0924V14.7692ZM7.38587 3.80769V2.65385H10.8098V3.80769H7.38587Z",
    fill: "#F04A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5bfee86681f7312dc753fb7e0cd7aec4.svg";
export { ForwardRef as ReactComponent };